/**
 * BatchGeoEmailService is a simple wrapper to handle all of
 * the api requests to the /email endpoint on the node server.
 *
 * @example
 * //first init BatchGeoEmailService with the proper data
 *
 * var refundEmail = new BatchgeoEmailService({
 *     emailType: 'subscriberRefund',
 *     recipient: 'bobnearents@gmail.com',
 *     data: '{"name": "bob"}'
 * })
 *
 * //now we can send the email out using the sendEmail method
 * refundEmail.sendEmail(function(response) {
 *     //you can include a callback if you want to do something with the response
 *     console.log(response)
 * });
 *
 * @param {object} options An options hash to setup your form
 * @param {string} options.emailType The type of email your sending,
 * these names can be found in the batchgeo-node repo.
 * @param {string} options.recipient The email address this is being sent to.
 * @param {json} options.data The data used to populate the email template.
 */
(function (window) {
  var BatchGeoEmailService = function (options) {
    this.settings = $.extend(
      true,
      {
        emailType: null,
        recipient: null,
        data: {},
        baseUrl: BatchGeoStore.getState().App.nodeServiceBaseUrl,
      },
      options,
    );

    if (options.data) this._initializeData(options.data);
  };

  /**
   * This just parses the JSON data passed from the constructor and
   * stores it to the settings.data object.
   *
   * @param {json} data an object with values to pass to the email template.
   * The keys change depending on which emailType we're using.
   *
   * @private
   * @returns {undefined}
   */
  BatchGeoEmailService.prototype._initializeData = function (data) {
    this.settings.data = JSON.parse(data);
  };

  /**
   * This changes the recipient in the settings to the param given. This
   * allows for a module to send a similar email to multiple addresses
   * without having to init again.
   *
   * @param {string} recipient a string as an email address.
   *
   * @returns {undefined}
   */
  BatchGeoEmailService.prototype.changeRecipient = function (recipient) {
    this.settings.recipient = recipient;
  };

  /**
   * This makes an a api request with the current settings. We can include a
   * callback in the param to handle the response message as needed.
   *
   * @param {function} callback callback has 1 param and that's the the success
   * response or the error repsonse message from the api.
   *
   * @return {undefined}
   */
  BatchGeoEmailService.prototype.sendEmail = function (callback) {
    var self = this;
    var language = BatchGeoStore.getState().App.language;
    $.ajax({
      url: self.settings.baseUrl + "/email",
      type: "POST",
      async: false,
      cache: false,
      timeout: 5000,
      data: {
        to: self.settings.recipient,
        templateName: self.settings.emailType,
        language: language,
        data: self.settings.data,
        from: self.settings.from,
      },
      error: function (e) {
        if (!BatchGeoStore.getState().App.isDev)
          Sentry.captureException(new Error(e.responseText));
        if (callback) callback(e.responseText);
      },
      success: function (msg) {
        if (callback) callback(msg);
      },
    });
  };
  window.BatchGeoEmailService = BatchGeoEmailService;
})(window);
